import { Button, styled } from '@mui/material';

export const StyledTab = styled(Button)(({ theme }) => ({
  padding: theme.spacing(0.2, 1),
  color: theme.palette.custom.OV.sys.onSurfaceVariant,
  background: 'transparent',
  border: `1px solid ${theme.palette.custom.OV.sys.onSurfaceVariant}`,

  '&.Mui-disabled': {
    background: theme.palette.custom.OV.sys.surfaceContainerHighest,
    border: `1px solid ${theme.palette.custom.OV.sys.surfaceContainerHighest}`,
    color: theme.palette.custom.OV.sys.onSurfaceVariant,
  },
}));
